import _slicedToArray from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/regenerator/index.js";
import { HttpResponse } from "@smithy/protocol-http";
import { headStream, splitStream } from "@smithy/util-stream";
var THROW_IF_EMPTY_BODY = {
  CopyObjectCommand: true,
  UploadPartCopyCommand: true,
  CompleteMultipartUploadCommand: true
};
var MAX_BYTES_TO_INSPECT = 3000;
export var throw200ExceptionsMiddleware = function throw200ExceptionsMiddleware(config) {
  return function (next, context) {
    return /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(args) {
        var _bodyCopy;
        var result, response, statusCode, sourceBody, isSplittableStream, bodyCopy, body, _yield$splitStream, _yield$splitStream2, bodyBytes, bodyStringTail, err;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return next(args);
              case 2:
                result = _context2.sent;
                response = result.response;
                if (HttpResponse.isInstance(response)) {
                  _context2.next = 6;
                  break;
                }
                return _context2.abrupt("return", result);
              case 6:
                statusCode = response.statusCode, sourceBody = response.body;
                if (!(statusCode < 200 || statusCode >= 300)) {
                  _context2.next = 9;
                  break;
                }
                return _context2.abrupt("return", result);
              case 9:
                isSplittableStream = typeof (sourceBody === null || sourceBody === void 0 ? void 0 : sourceBody.stream) === "function" || typeof (sourceBody === null || sourceBody === void 0 ? void 0 : sourceBody.pipe) === "function" || typeof (sourceBody === null || sourceBody === void 0 ? void 0 : sourceBody.tee) === "function";
                if (isSplittableStream) {
                  _context2.next = 12;
                  break;
                }
                return _context2.abrupt("return", result);
              case 12:
                bodyCopy = sourceBody;
                body = sourceBody;
                if (!(sourceBody && typeof sourceBody === "object" && !(sourceBody instanceof Uint8Array))) {
                  _context2.next = 21;
                  break;
                }
                _context2.next = 17;
                return splitStream(sourceBody);
              case 17:
                _yield$splitStream = _context2.sent;
                _yield$splitStream2 = _slicedToArray(_yield$splitStream, 2);
                bodyCopy = _yield$splitStream2[0];
                body = _yield$splitStream2[1];
              case 21:
                response.body = body;
                _context2.next = 24;
                return collectBody(bodyCopy, {
                  streamCollector: function () {
                    var _streamCollector = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(stream) {
                      return _regeneratorRuntime.wrap(function _callee$(_context) {
                        while (1) {
                          switch (_context.prev = _context.next) {
                            case 0:
                              return _context.abrupt("return", headStream(stream, MAX_BYTES_TO_INSPECT));
                            case 1:
                            case "end":
                              return _context.stop();
                          }
                        }
                      }, _callee);
                    }));
                    function streamCollector(_x2) {
                      return _streamCollector.apply(this, arguments);
                    }
                    return streamCollector;
                  }()
                });
              case 24:
                bodyBytes = _context2.sent;
                if (typeof ((_bodyCopy = bodyCopy) === null || _bodyCopy === void 0 ? void 0 : _bodyCopy.destroy) === "function") {
                  bodyCopy.destroy();
                }
                bodyStringTail = config.utf8Encoder(bodyBytes.subarray(bodyBytes.length - 16));
                if (!(bodyBytes.length === 0 && THROW_IF_EMPTY_BODY[context.commandName])) {
                  _context2.next = 31;
                  break;
                }
                err = new Error("S3 aborted request");
                err.name = "InternalError";
                throw err;
              case 31:
                if (bodyStringTail && bodyStringTail.endsWith("</Error>")) {
                  response.statusCode = 400;
                }
                return _context2.abrupt("return", result);
              case 33:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();
  };
};
var collectBody = function collectBody() {
  var streamBody = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Uint8Array();
  var context = arguments.length > 1 ? arguments[1] : undefined;
  if (streamBody instanceof Uint8Array) {
    return Promise.resolve(streamBody);
  }
  return context.streamCollector(streamBody) || Promise.resolve(new Uint8Array());
};
export var throw200ExceptionsMiddlewareOptions = {
  relation: "after",
  toMiddleware: "deserializerMiddleware",
  tags: ["THROW_200_EXCEPTIONS", "S3"],
  name: "throw200ExceptionsMiddleware",
  override: true
};
export var getThrow200ExceptionsPlugin = function getThrow200ExceptionsPlugin(config) {
  return {
    applyToStack: function applyToStack(clientStack) {
      clientStack.addRelativeTo(throw200ExceptionsMiddleware(config), throw200ExceptionsMiddlewareOptions);
    }
  };
};